import React from "react";
import { connect } from "react-redux";
import classes from "./Notification.module.css";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import { NOTIFICATION } from "../../utils/url-builder";
import socketIOClient from "socket.io-client";
import AppBar from "@material-ui/core/AppBar";
import LessonPathNotification from "./Lessonpathnotification";
import NewClassNotification from "./Newclassnotification";
import NewAssessmentNotification from "./Newassessmentnotification";
import BroadcastNotification from "./Broadcastnotification";
import EndClassNotification from "./EndClassnotification";
import BBBStartNotification from "./BBBstartnotification";
import SchedulerNotification from "./SchedulerNotification";
import { withTranslation } from "react-i18next";

import EmptyMessageComponent from "../custom-components/EmptyMessageComponent/empty-Message";
import {
  getNotifications,
  deleteNotifications,
} from "../../store/actions/notification.action";
import {
  notificationUpdate,
  addPost,
  deletePostByNotification,
} from "../../store/actions/classfeed.action";
import {
  getNotificationToken,
  getKneuraId,
  setBoardInfo,
  setClassInfo,
  getClassInfo,
} from "../../utils/authentication-access";
import ConferenceLinkNotification from "./ConferenceLinkNotification";

class Notification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      socket: socketIOClient(NOTIFICATION.getEndPoint(getNotificationToken())),
    };
  }

  async componentDidMount() {
    // this.setState({socket: socketIOClient(this.state.endpoint)});
    const classInfo = getClassInfo();
    this.state.socket.on("connect", this.loginToSocket);
    this.state.socket.on("notification", this.getNotification);
    await this.props.getNotifications(getKneuraId());
    if (classInfo && classInfo.kneuraId) {
      this.setState({ classId: classInfo.kneuraId });
    }
    if (this.props.notificationCount > 0) {
      this.props.gotoNotification();
    }
  }

  componentWillUnmount() {
    this.state.socket.close();
  }

  loginToSocket = () => {
    // console.log('connected');
  };

  getNotification = (msg) => {
    if (msg.message.type == "NEW_WALL_POST") {
      let postobj = JSON.parse(msg.message.postObj);
      if (postobj.classId == this.state.classId) {
        this.props.addPost(postobj.id, postobj.classId);
      }
    } else if (msg.message.type == "UPDATE_WALL_POST") {
      let postobj = JSON.parse(msg.message.postObj);
      if (postobj.classId == this.state.classId) {
        this.props.notificationUpdate(postobj.id, postobj.classId);
      }
    } else if (msg.message.type == "DELETE_WALL_POST") {
      let postobj = JSON.parse(msg.message.postObj);
      this.props.deletePostByNotification(postobj.id);
    } else if (msg.message.type == "NEW_WALL_COMMENT") {
      let postobj = JSON.parse(msg.message.postObj);
      if (postobj.classId == this.state.classId) {
        this.props.notificationUpdate(postobj.postId, postobj.classId);
      }
    } else if (msg.message.type == "UPDATE_WALL_COMMENT") {
      let postobj = JSON.parse(msg.message.postObj);
      if (postobj.classId == this.state.classId) {
        this.props.notificationUpdate(postobj.postId, postobj.classId);
      }
    } else if (msg.message.type == "DELETE_WALL_COMMENT") {
      let postobj = JSON.parse(msg.message.postObj);
      if (postobj.classId == this.state.classId) {
        this.props.notificationUpdate(postobj.postId, postobj.classId);
      }
    } else {
      this.props.getNotifications(getKneuraId());
      this.props.gotoNotification();
    }
  };

  clearAll = () => {
    this.props.deleteNotifications(getKneuraId());
  };

  closeNotification = () => {
    this.props.closeNotification();
  };

  showNotificationMessage = (msg) => {
    this.props.showSnackBarMessage(msg);
  };

  //   startTest=(id)=>{
  // this.props.history.push("/start-test?assessmentId=" + id);
  //   }

  showLessonPlan = (info) => {
    //setBoardinfo
    // setBoardInfo(info);
    this.props.history.push("/class");
  };

  gotoClass = (info) => {
    this.props.gotoclass(info);
  };

  SelectClass = () => {
    //set Classinfo
    this.props.history.push("/dashboard");
    this.props.closeNotification();
  };

  render() {
    const { t } = this.props;
    return (
      <Drawer
        open={this.props.openNotification}
        onClose={this.closeNotification}
      >
        <div className={classes.NotificationGrid}>
          <AppBar position="sticky" color="white" elevation={0}>
            <div className={classes.HeaderGrid}>
              <Icon
                className={classes.BackButton}
                onClick={this.closeNotification}
              >
                {" "}
                arrow_back
              </Icon>
              <div className={classes.NotificationHeader}>
                {t("NOTIFICATIONS")}
              </div>

              {/* <Button
                variant="outlined"
                size="small"
                color="primary"
                onClick={this.clearAll}
              >
                {t("Clear all")}
              </Button> */}
            </div>
          </AppBar>

          {this.props.notifications.length > 0 ? (
            this.props.notifications.map((item) =>
              item.type == "NEWLESSONPLAN" ? (
                <LessonPathNotification
                  gotoLessonPath={this.showLessonPlan}
                  info={item}
                  history={this.props.history}
                  showMessage={this.showNotificationMessage}
                />
              ) : item.type == "BROADCAST" ? (
                <BroadcastNotification info={item} />
              ) : item.type == "NEWASSESSMENT" ? (
                <NewAssessmentNotification
                  info={item}
                  history={this.props.history}
                />
              ) : item.type == "NEWCLASS" ? (
                <NewClassNotification
                  closeNotification={this.props.closeNotification}
                  openClass={this.gotoClass}
                  info={item}
                  history={this.props.history}
                />
              ) : item.type == "LIVE_CLASS_STARTED" ? (
                <BBBStartNotification
                  info={item}
                  history={this.props.history}
                  showMessage={this.showNotificationMessage}
                />
              ) : item.type === "NEW_CONFERENCE_LINK" ? (
                <ConferenceLinkNotification
                  info={item}
                  history={this.props.history}
                />
              ) : item.type === "LIVE_CLASS_ENDED" ? (
                <EndClassNotification
                  info={item}
                  history={this.props.history}
                />
              ) : item.type === "SCHEDULER" ? (
                <SchedulerNotification
                  info={item}
                  history={this.props.history}
                  closeNotification={this.props.closeNotification}
                  openClass={this.gotoClass}
                  openScheduler={() =>
                    this.props.history.push("/dashboard/scheduler")
                  }
                />
              ) : (
                " "
              ),
            )
          ) : (
            <EmptyMessageComponent text={t("No Notifications")} size="small" />
          )}
        </div>
      </Drawer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    notifications: state.notificationReducer.notifications,
    notificationCount: state.notificationReducer.notificationCount,
  };
};

export default connect(mapStateToProps, {
  getNotifications,
  deleteNotifications,
  notificationUpdate,
  deletePostByNotification,
  addPost,
})(withTranslation()(Notification));
